var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgToolFilled = function SvgToolFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 8a7 7 0 0 1 9.353-6.595 1 1 0 0 1 .371 1.65L16.48 5.321c-.318.321-.477.482-.552.66a1 1 0 0 0 .002.781c.076.178.236.338.556.657.321.32.481.481.66.557a1 1 0 0 0 .781 0c.178-.075.339-.235.66-.554l2.304-2.293a1 1 0 0 1 1.64.346 7 7 0 0 1-8.193 9.325 16 16 0 0 0-.583-.134l-.012.011a9 9 0 0 0-.288.281l-6.248 6.248a3.121 3.121 0 1 1-4.414-4.414l6.248-6.248a9 9 0 0 0 .281-.287c.016-.018.007-.037 0-.066a16 16 0 0 0-.123-.53A7 7 0 0 1 9 8",
    clipRule: "evenodd"
  })));
};
export default SvgToolFilled;